import get from 'lodash-es/get'
import isEmpty from 'lodash-es/isEmpty'
import isEqual from 'lodash-es/isEqual'
import pick from 'lodash-es/pick'
import includes from 'lodash-es/includes'
import omitBy from 'lodash-es/omitBy'
import querystring from 'query-string'

import { Site } from '../constants/siteList'

import {
  searchApiParams,
  searchApiFilterParams
} from '../constants/searchQueryWhitelist'
import filterParamsConfig from '../constants/filterParamsConfig'
import { getConfigBySite } from '../../config/sites'

export const isCategoryOnlySearch = query => {
  return includesExactlyTheseFacetingParams(query, ['category'])
}

export const isHostingSetupSearch = query => {
  const queryFacetingParams = pick(query, searchApiFilterParams)
  const queryFacetingParamsWithValues = omitBy(queryFacetingParams, isEmpty)
  const facetingParamKeys = Object.keys(queryFacetingParamsWithValues)
  return includes(facetingParamKeys, 'hosting_setup')
}

export const isFirstPage = query => {
  return isEmpty(query.page) || [0, 1].includes(parseInt(query.page))
}

export const includesExactlyTheseFacetingParams = (
  query,
  expectedParamKeys
) => {
  const queryFacetingParams = pick(query, searchApiFilterParams)
  const queryFacetingParamsWithValues = omitBy(queryFacetingParams, isEmpty)
  const facetingParamKeys = Object.keys(queryFacetingParamsWithValues)

  return isEqual(facetingParamKeys.sort(), expectedParamKeys.sort())
}

/**
 * Build the search query string
 * @param  {Object} query
 * @return {String} the search query string pass to public-search
 */
export const buildSearchQueryString = (parsedLocation, currentSite) => {
  const filteredQueryObject = Object.keys(parsedLocation)
    .filter(param => {
      // only keep the queries in the public-search query whitelist
      return searchApiParams.indexOf(param) >= 0
    })
    .filter(param => {
      // filter empty params
      return !!parsedLocation[param]
    })
    .reduce((prev, curr) => {
      if (Array.isArray(parsedLocation[curr])) {
        const arrayLength = parsedLocation[curr].length
        prev[curr] = parsedLocation[curr][arrayLength - 1]
      } else if (get(filterParamsConfig, `${curr}.isArrayFormat`)) {
        prev[curr] = parsedLocation[curr].split(',')
      } else {
        prev[curr] = parsedLocation[curr]
      }
      return prev
    }, {})

  const pageSize = getConfigBySite(currentSite, 'common.search_page_size')
  const site = `${currentSite}.net`
  const sortBy =
    filteredQueryObject.sort_by ||
    (filteredQueryObject.term && 'relevance') ||
    (currentSite === Site.photodune ? 'trending' : 'date')

  // we have a few default value here
  const newQueryObject = Object.assign({}, filteredQueryObject, {
    site,
    page: filteredQueryObject.page || 1,
    page_size: filteredQueryObject.page_size || pageSize,
    sort_by: sortBy
  })

  return querystring.stringify(newQueryObject, { arrayFormat: 'bracket' })
}
